ixModuleRouting("impactx.fallbackstartpage", {
    "/fallbackstartpage": {
        template: "<ixa-fallback-start-page></ixa-fallback-start-page>",
        templateUrl:
            "modules/fallbackstartpage/templates/fallbackstartpage.html",
        controller: "FallBackStartPageCtrl",
        process: "Any"
        // no workspace to prevent always triggering an init of shop-workspace
        // (which might cause errors if the user does not have that workspace)
    },
});
